/* Material */
import useStyles from './Brands.styles'

/* Types */
import { tBrands } from 'src/shared/frontendTypes/brand'

/* Components */
import BrandLogo from './BrandLogo'

/* Swiper */
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, {
  Mousewheel,
  Navigation,
} from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'

SwiperCore.use([
  Mousewheel,
  Navigation,
])

const hasSliderLogo = (brand: tBrands[number]) => Boolean(brand.logos?.mono?.xs)

const sliderInteractionProps = {
  cssMode: true,
  mousewheel: { forceToAxis: true, releaseOnEdges: true, sensitivity: .75, thresholdDelta: 12 },
  watchOverflow: true,
  speed: 360,
  roundLengths: true,
  slidesPerGroupAuto: true,
  simulateTouch: true,
  grabCursor: true,
  allowTouchMove: true,
  passiveListeners: true,
  touchEventsTarget: 'container',
  touchAngle: 32,
  threshold: 5,
  resistanceRatio: .2,
  touchReleaseOnEdges: true,
  longSwipes: true,
  longSwipesRatio: .18,
  longSwipesMs: 180,
  followFinger: true,
  touchStartPreventDefault: false,
  touchMoveStopPropagation: false,
  preventInteractionOnTransition: false,
  shortSwipes: true,
  touchRatio: 1,
  preventClicks: false,
  preventClicksPropagation: false,
  centeredSlides: false,
  watchSlidesProgress: false,
} as const

const Brands = (props:{brands:tBrands}) => {
  const { brands } = props
  const classes = useStyles()
  const brandsWithLogo = brands.filter(hasSliderLogo)

  if (brandsWithLogo.length === 0) return null

  return <div className={classes.brandsCarousel}>

    <Swiper
      className={classes.brandSwiper}
      direction='horizontal'
      spaceBetween={40}
      slidesPerView='auto'
      {...sliderInteractionProps}
      navigation={{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }}
    
    >

      {brandsWithLogo.map(brand => (
        <SwiperSlide key={brand.id}>
          <BrandLogo brand={brand} />
        </SwiperSlide>
      ))}

    </Swiper>

    <div className="swiper-button-prev" />
    <div className="swiper-button-next" /> 

  </div>

}

export default Brands
